import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import React from "react";
import { Link } from "react-router-dom";

import { PAGE_SIZE_OPTIONS } from "../../Constants/FieldOptions";

function UserListDesktop(props) {
  const {
    listData,
    setPageSize,
    pageSize,
    previousCursors,
    onPreviousClicked,
    onNextClicked,
    onDeleteOrgUser,
  } = props;
  return (
    <div class="b-table">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {listData &&
              listData.map(function (datum, i) {
                return (
                  <tr key={datum.id}>
                    <td data-label="Name">
                      {datum.firstName || datum.lastName
                        ? `${datum.firstName} ${datum.lastName}`
                        : "N/a"}
                    </td>
                    <td data-label="Email">{datum.email}</td>

                    <td data-label="Trial Status">
                      <span
                        class={`${
                          datum.status === "active"
                            ? "tag is-success is-light"
                            : datum.status === "deleted"
                            ? "tag is-danger is-light"
                            : "tag is-success is-light"
                        }`}
                      >
                        {datum.status}
                      </span>
                    </td>
                    <td data-label="Created">
                      {DateTime.fromSeconds(datum.created).toLocaleString(
                        DateTime.DATETIME_MED
                      )}
                    </td>
                    <td class="is-actions-cell">
                      <div class="buttons is-right">
                        {datum.status === "active" && (
                          <div
                            onClick={() => onDeleteOrgUser(datum?.id, "active")}
                            className="button is-small"
                          >
                            <FontAwesomeIcon className="mdi" icon={faTrash} />
                          </div>
                        )}
                        <Link
                          to={`/org-user/${datum?.id}`}
                          class="button is-small is-primary"
                          type="button"
                        >
                          <FontAwesomeIcon className="mdi" icon={faEye} />
                          &nbsp;View
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <div class="columns">
          <div class="column is-half">
            <span class="select">
              <select
                class={`input has-text-grey-light`}
                name="pageSize"
                onChange={(e) => setPageSize(parseInt(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map(function (option, i) {
                  return (
                    <option
                      selected={pageSize === option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  );
                })}
              </select>
            </span>
          </div>
          <div class="column is-half has-text-right">
            {previousCursors.length > 0 && (
              <button class="button" onClick={onPreviousClicked}>
                Previous
              </button>
            )}
            {listData.hasNextPage && (
              <>
                <button class="button" onClick={onNextClicked}>
                  Next
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserListDesktop;
